import { z } from 'zod';

import zodLocales from 'common/zod/locales';

const companyLegalInfoSchema = z.object({
  inseeLegalFormCode: z.string().min(1, zodLocales.errors.required),
  legalName: z.string().min(1, zodLocales.errors.required).trim(),
});

export type CompanyLegalInfoSchema = z.infer<typeof companyLegalInfoSchema>;

export default companyLegalInfoSchema;
